<template>
  <div class="breadcrumbs">
    <v-breadcrumbs :items="items" divider=">" v-if="items.length > 1">
      <v-breadcrumbs-item
        slot="item"
        slot-scope="{ item }"
        :to="item.disabled ? undefined : item.to"
        :disabled="item.disabled"
        exact
        @click="!item.disabled && cutItems(item.text)"
      >
        {{ item.text }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: {
    items: {
      type: Array
    }
  },
  data() {
    return {}
  },
  methods: {
    cutItems(itemText) {
      let index = this.items.findIndex(item => item.text === itemText)
      let array = this.items.slice(0, index + 1)
      this.$emit('changeBreadcrumbsArray', array)
    },
  },
}
</script>

<style>
.v-breadcrumbs__item {
  font-family: "Montserrat", sans-serif;
}
</style>
